/// <amd-module name="Wit/SprintsHub/SprintsView/Components/Analytics/AnalyticsTab" />
import * as React from "react";
import { TfsComponent } from "Tfs/Platform/TfsComponent";
import { ObservableValue } from "VSS/Core/Observable";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { Observer } from "VSSUI/Observer";
import { IVssKeyboardShortcutService } from "VSS/Platform/KeyboardShortcuts";
import * as Resources from "Wit/SprintsHub/SprintsView/Resources";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export interface IAnalyticsTabProps {
    iterationPath: string;
    lastRefresh: ObservableValue<Date>;
}

export class AnalyticsTab extends TfsComponent<IAnalyticsTabProps> {
    private shortcutService: IVssKeyboardShortcutService;

    constructor(props: IAnalyticsTabProps, context?: any) {
        super(props, context);

        this.shortcutService = this.context.pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");
    }

    public componentDidMount() {
        this.registerShortcuts();
        this.publishAnalyticsTabTelemetry("AnalyticsTabAccess");
    }

    public componentDidUpdate(prevProps: Readonly<IAnalyticsTabProps>, prevState: Readonly<{}>, snapshot?: {} | undefined): void {
        if(prevProps.iterationPath !== this.props.iterationPath){
            this.publishAnalyticsTabTelemetry("DropDownClick-SprintPicker");
        }   
    }

    private publishAnalyticsTabTelemetry(scenario: string){
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("Sprints", "AnalyticsTab", {
            Scenario: scenario,
            TeamId: this.teamData?.id,
            ParentPageName: "NewBoardsHub-Sprints"
        });
    }

    private registerShortcuts = (): void => {
        this.shortcutService.registerShortcut(Resources.Analytics, {
            combos: ["z"],
            description: Resources.ToggleFullScreenMode,
            action: () => {
                const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                layoutManager.toggleFullScreenMode();
            }
        });
    }

    public componentWillUnmount() {
        this.unregisterShortcuts();
    }

    private unregisterShortcuts = () => {
        this.shortcutService.removeShortcutGroup(Resources.Analytics);
    };

    public static getRefreshMenuItem(lastRefresh: ObservableValue<Date>): IHeaderCommandBarItem {
        const refreshMenuItem: IHeaderCommandBarItem = {
            ariaLabel: Resources.Refresh,
            iconProps: { iconName: "Refresh" },
            id: "refresh",
            onActivate: () => {
                lastRefresh.value = new Date();
            },
            rank: 300,
            subtle: true
        };
        return refreshMenuItem;
    }

    public render() {
        return (
            <div className="page-content analytics-content scroll-auto">
                <Observer lastRefresh={this.props.lastRefresh}>
                    {(observableProps: { lastRefresh: Date }) => {
                        return (
                            <WrappedComponent
                                key={"burndown-report"}
                                wrappedType={"BurndownReport"}
                                dependencies={["ms.vss-reporting-web.burndown-report-content"]}
                                wrappedProps={{
                                    teamId: this.teamData?.id,
                                    teamName: this.teamData?.name,
                                    projectId: this.projectData?.id,
                                    iterationPath: this.props.iterationPath,
                                    // TODO:
                                    // iterationStartDate: iteration.startDateUTC,
                                    // IterationEndDate: iteration.endDateUTC,
                                    isMinimalChart: false,
                                    isLightbox: false,
                                    lastRefresh: observableProps.lastRefresh
                                }}
                            />
                        );
                    }}
                </Observer>
            </div>
        );
    }
}
